import styled from 'styled-components';

const TitleContainer = styled.div`
  padding: 15px;
  background-color: ${props=>props.theme.cores.fundo.container.secundario};
  border: 1px solid ${props => props.theme.cores.fundo.container.secundario};
  box-shadow: ${props=>props.theme.sombras.padrao}
`;

const Title = styled.h1`
  font-size: 1.50rem;
  color: #333;
  font-weight: 400;
  margin: 0;

`;

interface PageTitleProps {
  title: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ title }) => (
  <TitleContainer>
    <Title>{title}</Title>
  </TitleContainer>
);

export default PageTitle;